"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("@emotion/styled"));
exports.default = styled_1.default.span `
	width: 100%;

	.tn-logo {
		display: block;
		width: 100%;
	}

	.tn-logo__inner {
		display: block;
		background-size: contain;
		background-repeat: no-repeat;
		font: 0/0 a;
		padding: 0 0;
		background-image: url("${(props) => `${props.logoUrl || './logo-emblem.svg'}`}");
		height: 40px;
	}
`;
//# sourceMappingURL=logo.styled.js.map